import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';
import { productos } from '../../../idiomas/i18n/perfiles/catalogos/zh2';

@Injectable({
  providedIn: 'root'
})
export class ForAllService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }
  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusForAll(productoId: any){
    this.obtienInfo();
    let datos: any = {productoId,	forall: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  getStatusForAllMedir(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio,	forall: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusForAll(datos){
    this.obtienInfo();
    console.log("DATOS_",datos);
    // let datos: any = {fechaCertificar: anio,	forall: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoForAll(datos){
    this.obtienInfo();
    console.log("DATOS_",datos);
    // let datos: any = {fechaCertificar: anio,	forall: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoForAllMedir(id: any){
    this.obtienInfo();
    let datos: any = {productoId: id,	forall: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  guardaStatusForAllMedir(id: any){
    this.obtienInfo();
    let datos: any = {productoId: id,	forall: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  public getPracticesSaved(data) {
this.obtienInfo();
    return this.http.post(DATOS_API.url+DATOS_API.endpoints.forAll.postForallGet+this.idEmpresa,data);

  }

  getIdiomasEncuesta(datos) {
this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.forAll.getLanguajesListSelected + this.idEmpresa, datos);
  }

}
